import { useRemoveAccountInsulin } from "@tandemdiabetes/sugarmate-api-react-client"
import { transformAccountInsulin } from "./transformAccountInsulin"
import { useDeleteCollectionItem } from "src/hooks/rxdb"
import { CollectionKey } from "src/types"

export function useDeleteAccountInsulin() {
  return useDeleteCollectionItem(
    CollectionKey.AccountInsulin,
    "account_insulin",
    useRemoveAccountInsulin,
    transformAccountInsulin,
  )
}
